import { render, staticRenderFns } from "./postedProduct.vue?vue&type=template&id=5f8a3217&scoped=true"
import script from "./postedProduct.vue?vue&type=script&lang=js"
export * from "./postedProduct.vue?vue&type=script&lang=js"
import style0 from "./postedProduct.vue?vue&type=style&index=0&id=5f8a3217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a3217",
  null
  
)

export default component.exports